import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import image1 from "assets/img/DCP_0003.JPG";
import image2 from "assets/img/DSC_0027.JPG";
import image3 from "assets/img/DSC04643.JPG";
import image4 from "assets/img/DSC06798.JPG";
import image5 from "assets/img/100_1494.jpg";

import styles from "assets/jss/views/componentsSections/carouselStyle.js";
import "assets/css/_plugin-react-slick.scss";

const useStyles = makeStyles(styles);

export default function SectionCarousel() {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
            <Card carousel>
              <Carousel {...settings}>
                <div>
                  <img src={image1} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Péndulo del reloj en la Iglesia San Pedro
                    </h4>
                  </div>
                </div>
                <div>
                  <img
                    src={image2}
                    alt="Second slide"
                    className="slick-image"
                  />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Exposiciones culturales en salas de cultura y museos
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image3} alt="Third slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Referentes culturales: Disman Anchieri y Elman Sánchez (fallecido) compartiendo la vida social en Durazno
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image4} alt="Fourd slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Museo con historia: primera sede presidencial del Uruguay es hoy el museo Casa de Rivera, el historiador Oscar Padrón al frente
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image5} alt="Fifth slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Historia: desde la presencia de establecimiento jesuita en San Borjas hasta una cápsula del tiempo en su plaza fundacional.
                    </h4>
                  </div>
                </div>
              </Carousel>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} className={classes.marginAuto}>
            publicidad
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
